import React from 'react'
import './Online_degree.css'
import Common_title from '../../common_components/common-title/Common_title'
import { Link } from 'react-router-dom'

const Online_degree = () => {
    return (
        <>
            <section className='Online_degree_section'>
                <div className='container'>
                    <Common_title className='text-center' title='DPU Online Degree Program' subtitle='Promotions That Resonate. Emotions That Connect.' />

                    <Link to={"https://www.youtube.com/embed/OkM5v68Qz74?autoplay=1&mute=1&loop=1&playlist=OkM5v68Qz74"} target='_blank'>
                        <div className='vdosection'>
                            <video className="video-holder" controls autoPlay loop muted playsinline >
                                <source className="videosec" src={process.env.PUBLIC_URL + "/assets/images/video/home/online-degree/online-degree.mp4"} ></source>
                            </video>
                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Online_degree